<template>
  <div>
    <v-card-title v-if="title !== undefined" class="mx-n4"
      >{{ title }}
      <v-spacer></v-spacer>
    </v-card-title>
      <v-row
          v-if="isLoading"
          align="center"
          justify="center"
          style="height:200px"
        >
          <v-progress-circular
            :size="75"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-row>
        <slot v-else name="content"></slot>
  </div>
</template>

<script>
export default {
props:{
    title: {
        type: String,
    },
    isLoading: {
        type: Boolean,
        default: false,
    }
}
}
</script>

